import { ChooseSubdomainPage } from '@/components/ChooseSubdomainPage';
import type { AdminRouterContext } from '@/context/AdminRouterContext';
import { SitesRepository } from '@/repositories/SitesRepository';
import { createFileRoute, redirect } from '@tanstack/react-router'
import { queryClient } from '@/lib/queryClient';
import { siteQueryKeys } from '@/hooks/useSiteQuery';

export const Route = createFileRoute('/_protected/create-site')({
  beforeLoad: async ({ context }: { context: AdminRouterContext }) => {
    const userId = context.auth.user?.id;

    // Check cache first
    const cachedData = queryClient.getQueryData(siteQueryKeys.site(userId!));
    let data;
    
    if (cachedData) {
      data = cachedData;
    } else {
      const result = await SitesRepository.getByUserId();
      if (!result.error && result.data) {
        // Prime the cache
        queryClient.setQueryData(siteQueryKeys.site(userId!), { data: result.data, error: null });
        data = result.data;
      } else {
        data = null;
      }
    }
    
    if (data) {
      throw redirect({
        to: '/',
      });
    }
  },
  component: RouteComponent,
})

function RouteComponent() {
  return <ChooseSubdomainPage />;
}
